<template>
  <NavBar v-if="headerStore.menuItems && ready" />
  <div>
    <div class="grid-cols-1 md:grid-cols-1 md:col-span-1 col-span- bg-gray-50"></div>
    <div class="grid-cols-2 md:grid-cols-2 md:col-span-2 col-span-2"></div>
    <div class="grid-cols-3 md:grid-cols-3 md:col-span-3 col-span-3"></div>
    <div class="grid-cols-4 md:grid-cols-4 md:col-span-4 col-span-4"></div>
    <div class="grid-cols-5 md:grid-cols-5 md:col-span-5 col-span-5"></div>
    <div class="grid-cols-6 md:grid-cols-6 md:col-span-6 col-span-6"></div>
    <div class="grid-cols-7 md:grid-cols-7 md:col-span-7 col-span-7"></div>
    <div class="grid-cols-8 md:grid-cols-8 md:col-span-8 col-span-8"></div>
    <div class="grid-cols-9 md:grid-cols-9 md:col-span-9 col-span-9"></div>
    <div class="grid-cols-10 md:grid-cols-10 md:col-span-10 col-span-10"></div>
    <div class="grid-cols-11 md:grid-cols-11 md:col-span-11 col-span-11"></div>
    <div class="grid-cols-12 md:grid-cols-12 md:col-span-12 col-span-12"></div>
  </div>
</template>

<script setup>
import NavBar from './components/NavBar.vue'

import { useHeaderStore } from '@/stores'

import { onMounted, ref } from 'vue'

const headerStore = useHeaderStore()

const ready = ref(false)

onMounted(async () => {
  await (headerStore.fetchData())
  ready.value = true
})

</script>